import {ADD_VIEW_ERA} from './actions';


const initialState = {
  view_era: null
};
export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_VIEW_ERA:
      return Object.assign({}, state, {
        view_era: action.payload
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/era/Reducer.Era.js